var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, FormHelperText, FormLabel } from "@mui/material";
import { useFormLogic } from "../../context/FormLogicContext";
var DEFAULT_REQUIRED_TEXT = "*";
var Header = function (_a) {
    var _b;
    var element = _a.element, _c = _a.error, error = _c === void 0 ? false : _c, isRequiredProp = _a.isRequired;
    var globalConstraints = useFormLogic().globalConstraints;
    var name = element.name, title = element.title, description = element.description, isRequiredFromElement = element.isRequired;
    var isRequired = isRequiredProp !== null && isRequiredProp !== void 0 ? isRequiredProp : isRequiredFromElement;
    var requiredText = (_b = globalConstraints.requiredText) !== null && _b !== void 0 ? _b : DEFAULT_REQUIRED_TEXT;
    return (_jsxs(_Fragment, { children: [_jsxs(FormLabel, __assign({ error: error, sx: { mb: 1 } }, { children: [title || name, isRequired && requiredText && (_jsx(Box, __assign({ component: "span", "aria-hidden": "true", sx: { color: "error.main", ml: "3px" } }, { children: requiredText })))] })), description && (_jsx(FormHelperText, __assign({ error: error, sx: { mb: 1, mt: 0 } }, { children: description })))] }));
};
export default Header;
